import React from "react";
import styles from "./Styles";
import { Card, CardContent, Typography, List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import { Link } from "react-admin";
import { canAccess } from "../../rbac";

const RENTALS_ITEMS = [
  { to: "/pending_rentals", text: "Pending Rentals", permission: "pending_rentals" },
  { to: "/rentals_due", text: "Rentals Due", permission: "rentals_due" },
  { to: "/rentals", text: "Rental List", permission: "rentals" },
  { to: "/weekly_rentals", text: "Weekly Rentals", permission: "weekly_rentals" },
  { to: "/whiteboard", text: "Rentals Whiteboard", permission: "whiteboard" },
  { to: "/unentered_km_rentals", text: "Unentered KM", permission: "unentered_km_rentals" },
  { to: "/extra_km_rentals", text: "Extra KM Rentals", permission: "extra_km_rentals" },
  { to: "/reports", text: "Reports", permission: "reports" },
];

export class RentalsOptions extends React.Component {
  render() {
    return (
      <Card style={styles.cardStyle}>
        <Typography
          gutterBottom
          variant="h6"
          component="h2"
          style={styles.cardHeaderStyle}
        >
          Rentals
        </Typography>
        <CardContent style={styles.CardContent}>
          <List>
            {RENTALS_ITEMS.map(({ to, text, permission }) =>
              canAccess(permission) ? (
                <ListItem key={to}>
                  <Link to={to}>{text}</Link>
                </ListItem>
              ) : null
            )}
          </List>
        </CardContent>
      </Card>
    );
  }
}

export default RentalsOptions;



// WEBPACK FOOTER //
// ./src/components/dashboard/RentalsOptions.js